import { DeviceScreenSizes } from "@/custom-types/DeviceScreenSizes";

export default [
  DeviceScreenSizes.Mobile,
  DeviceScreenSizes.MobileMid,
  DeviceScreenSizes.Tablet,
  DeviceScreenSizes.Desktop,
  DeviceScreenSizes.Widescreen,
];
